import React from 'react';
import ReactDOM from 'react-dom';
import AOS from 'aos';
import App from './App';
import GlobalStyles from './styles/GlobalStyle';
import Typography from './styles/Typography';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();
ReactDOM.render(
  <>
    <GlobalStyles />
    <Typography />
    <App />
  </>,
  document.getElementById('root')
);
